import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const RefundPolicy = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Refund Policy</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="refund-policy">
                          <h6>Refund Policy for {APP_INFO.companyName}</h6>
                          <p>
                            <strong>Effective Date:</strong> 01.01.2025
                          </p>

                          <h6>Overview</h6>
                          <p>
                            This Refund Policy applies to all services offered
                            on the {APP_INFO.companyName} platform, which is
                            owned and operated by CHOTTU TELECOM. By using our
                            services, you agree to the terms outlined below.
                          </p>

                          <h6>
                            {APP_INFO.companyName} Responsibility for Refunds
                          </h6>
                          <h6>1. Failed Transactions</h6>
                          <p>
                            If a recharge, bill payment, or other transaction
                            fails due to a technical error on our side, and the
                            amount is deducted from your payment method, we will
                            initiate a refund after confirmation from the
                            payment gateway or service provider.
                          </p>
                          <p>
                            Refunds will be processed to your original payment
                            method within 7–14 working days. Any gateway
                            charges, taxes, or fees applied by third parties
                            will not be refundable.
                          </p>

                          <h6>2. Service Not Delivered</h6>
                          <p>
                            If you have received a successful payment
                            confirmation but did not receive the service (such
                            as recharge or bill clearance), you must report the
                            issue to{" "}
                            <a href="mailto:support@topupconnect.in">
                              support@topupconnect.in
                            </a>{" "}
                            within 48 hours.
                          </p>
                          <p>
                            If, after investigation, the failure is attributed
                            to our system or service integration, a full refund
                            (excluding charges) will be processed.
                          </p>

                          <h6>
                            {APP_INFO.companyName} Not Responsible for Refunds
                          </h6>
                          <h6>1. External Failures</h6>
                          <p>
                            We are not responsible for transaction failures
                            caused by third-party systems or external factors,
                            including:
                          </p>
                          <ul>
                            <li>Mobile network or internet issues</li>
                            <li>Power outages or device failures</li>
                            <li>
                              Bank server downtime or payment gateway errors
                            </li>
                            <li>Delays from telecom or utility providers</li>
                          </ul>

                          <h6>2. Completed Transactions</h6>
                          <p>
                            All successful transactions are final. Once a
                            recharge or bill payment is successfully processed
                            and confirmed, no refund or cancellation will be
                            allowed.
                          </p>

                          <h6>3. Incorrect Details Provided by User</h6>
                          <p>
                            Refunds will not be provided in the following cases:
                          </p>
                          <ul>
                            <li>Incorrect mobile or account number entered</li>
                            <li>Wrong operator or biller selection</li>
                            <li>Incorrect payment details provided</li>
                          </ul>
                          <p>
                            Users are advised to carefully verify all details
                            before proceeding with payment.
                          </p>

                          <h6>Refund Request Process</h6>
                          <p>
                            To initiate a refund request, email us at{" "}
                            <a href="mailto:support@topupconnect.in">
                              support@topupconnect.in
                            </a>{" "}
                            with the following:
                          </p>
                          <ul>
                            <li>Transaction ID or Order Number</li>
                            <li>Payment method used and reference ID</li>
                            <li>
                              Screenshot or payment receipt (if available)
                            </li>
                            <li>Brief description of the issue</li>
                          </ul>
                          <p>
                            Our support team will respond within 3–5 working
                            days. If eligible, the refund will be initiated to
                            your original source of payment.
                          </p>

                          <h6>Chargebacks</h6>
                          <p>
                            If you initiate a chargeback without contacting us
                            first, we reserve the right to suspend or terminate
                            your {APP_INFO.companyName} account. We encourage
                            you to reach out for resolution before escalating to
                            your payment provider.
                          </p>

                          <h6>Policy Updates</h6>
                          <p>
                            This Refund Policy may be revised from time to time.
                            Changes will be posted on our website with an
                            updated effective date. Continued use of our
                            services constitutes your acceptance of the modified
                            policy.
                          </p>

                          <h6>Legal Owner</h6>
                          <p>
                            This policy is issued under the legal entity CHOTTU
                            TELECOM, which owns and operates the brand{" "}
                            {APP_INFO.companyName}, located at:
                          </p>
                          <p>
                            Barasat - 1, Kathuria, Malikapur, Duttapukur
                            <br />
                            Barasat, North 24 Parganas, West Bengal - 700126
                          </p>
                          <p>
                            <strong>Email:</strong>{" "}
                            <a href={`mailto:${APP_INFO.email}`}>
                              {APP_INFO.email}
                            </a>
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
